module.exports = ReactDOMFactories;